import { safeDeepGetWithType } from "iotera-base/json";
import { TYPE_CARD_VALUE, TYPE_DROPDOWN_SELECTOR, TYPE_TITLE } from "../components/Preference";

export function getLayoutsFromDashboard(dashboard) {
    const layout = { lg: [] }

    for (let key in dashboard) {
        let currDash = dashboard[key];
        const layObj = {}
        const cat = safeDeepGetWithType(currDash, ['cat'], TYPE_CARD_VALUE)
        let h = safeDeepGetWithType(currDash, ['h'], 1)

        if (cat !== TYPE_TITLE && cat !== TYPE_DROPDOWN_SELECTOR) {
            h *= 2
        }
        layObj.w = safeDeepGetWithType(currDash, ['w'], 1)
        layObj.h = h
        layObj.x = safeDeepGetWithType(currDash, ['x'], 0)
        layObj.y = safeDeepGetWithType(currDash, ['y'], 0)
        layObj.i = key
        layObj.isDraggable = true
        layObj.isResizable = false

        layout.lg.push(layObj)
    }

    return layout
}